import React from "react";
import SortableHeaderCell from "./SortableHeaderCell";

function SortableTableHead({ children, sortConfig, handleSort }) {
  return (
    <thead className="border-b-2 border-[#FFDDD7]">
      <tr>
        {React.Children.map(children, (child) => {
          // Check if the child is a SortableHeader component
          if (
            React.isValidElement(child) &&
            child.type === SortableHeaderCell
          ) {
            // If it is, clone it and add the props automatically
            return React.cloneElement(child, {
              ...child.props,
              sortConfig,
              handleSort,
            });
          }
          // Otherwise, return the child as is (e.g., a regular <th>)
          return child;
        })}
      </tr>
    </thead>
  );
}

export default SortableTableHead;
